import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl' // Assuming you're using react-intl
import MessagespringLoading from './MessagespringLoading' // Adjust the import path as needed

/**
 * FullScreenLoader component that displays a centered loader with optional text
 * @param {Object} props - Component props
 * @param {number} props.size - Size of the loader
 * @param {string} props.messageId - Message ID for internationalization
 * @param {boolean} props.showText - Whether to show text under the loader
 * @param {string} props.className - Additional classes for the container
 * @param {Object} props.textProps - Props to pass to the text container
 */
const FullScreenLoader = ({
  size = 64,
  messageId = 'text.loading',
  showText = true,
  className = '',
  textProps = {},
  ...otherProps
}) => {
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-white z-50 ${className}`}
      {...otherProps}
    >
      <div className="flex flex-col items-center">
        <MessagespringLoading size={size} />

        {showText && (
          <div className="text-blue-950 mt-5 text-center" {...textProps}>
            <FormattedMessage id={messageId} />
          </div>
        )}
      </div>
    </div>
  )
}

FullScreenLoader.propTypes = {
  size: PropTypes.number,
  messageId: PropTypes.string,
  showText: PropTypes.bool,
  className: PropTypes.string,
  textProps: PropTypes.object,
}

export default FullScreenLoader
